import type { Router } from 'vue-router';
import { AppRoute } from '@/libs/routing';

/**
 * Leaves the search the way it was entered: back to the home when it was
 * opened from there, straight to the map when it was a deep link.
 */
export function closeSearch(router: Router) {
  if (router.options.history.state.back) router.back();
  else router.replace({ name: AppRoute.MAP });
}
